/* * Version: 1.0.0
 * Letzte Änderung: 16.09.2026, 13:55
 * Änderungshistorie: Erstellung des öffentlichen Turnier-Portals für die startplan-Subdomain.
 * Copyright: BAIT-Tech
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api';

const PublicTournamentListScreen = () => {
  // State für die Liste der Turniere, Ladezustand und Fehler
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();

  // Turniere beim Laden der Komponente vom Backend abrufen
  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        // Nutzt den öffentlichen Endpunkt (ohne Token)
        const { data } = await apiClient.get('/api/tournaments');
        setTournaments(data);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
        setLoading(false);
      }
    };

    fetchTournaments();
  }, []);

  // =============================================================================
  //  RENDER LOGIK
  // =============================================================================
  if (loading) return <div style={{ textAlign: 'center', padding: '50px', fontSize: '20px' }}>Turniere werden geladen...</div>;
  if (error) return <div style={{ color: 'red', textAlign: 'center', padding: '50px' }}>Fehler: {error}</div>;

  return (
    <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto', fontFamily: 'sans-serif' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>BAIT-Tech | Aktuelle Turniere</h1>
      
      {tournaments.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#777' }}>Derzeit sind keine Turniere aktiv.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
          {tournaments.map((t) => (
            <div 
              key={t._id} 
              style={{ 
                background: '#fff', 
                borderRadius: '8px', 
                padding: '20px', 
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                borderTop: '5px solid #007bff',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
            >
              <div>
                <h3 style={{ marginTop: '0', color: '#222' }}>{t.name}</h3>
                <p style={{ color: '#555', fontSize: '14px', marginBottom: '5px' }}>
                  <strong>Ort:</strong> {t.location || 'Nicht angegeben'}
                </p>
                <p style={{ color: '#555', fontSize: '14px' }}>
                  <strong>Zeitraum:</strong> {new Date(t.startDate).toLocaleDateString('de-AT')} - {new Date(t.endDate).toLocaleDateString('de-AT')}
                </p>
              </div>
              
              <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                <button 
                  onClick={() => navigate(`/turnier/${t._id}/startplan`)}
                  style={{ flex: 1, padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                  Startplan
                </button>
                <button 
                  onClick={() => navigate(`/turnier/${t._id}/ergebnisse`)}
                  style={{ flex: 1, padding: '10px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                  Ergebnisse
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PublicTournamentListScreen;